﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';
import { events as formEvents } from '../../feature/form/enable-form';

export const postcodeLookup = () => {

    const selectors = {
        root: '.form',
        searchField: '.js-postcode-lookup',
        field: '.form-field-group__input',
        postcodeField: '.form-field-group__postcode',
        addressList: 'js-address-list',
        searchButton: '.find-address-btn',
        resultsContainer: '.address-search',
        errorMessage: '.form-field-group__error',
        warningMessageLocation: '.form-section',
        warningMessage: '.form-field-group__warningMessage',
        manualAddressButton: '.manual-address-link',
        hiddenField: '.js-hidden-fields',
        visibleFieldToggle: 'form-field-group__hidden-fields--visible'
    };

    var config = {};

    var _makeRequest = function (service, dataObj, func)
    {
        service.url += '?' + ( new URLSearchParams( dataObj ) ).toString();
        var method = 'GET'
        let options = {
            method
        };
        fetch(service.url, options)
        .then((response) => response.json())
        .then((result) => {
            if (result.Items && result.Items[0].Error) {
                var dataMessage = result.Items[0];
                console.warn(`Error: ${dataMessage.Error}, ${dataMessage.Description}, ${dataMessage.Cause}, ${dataMessage.Resolution}`);
            }
            else
            {
                if (typeof func != 'function')
                {
                    console.warn(func + ' is not a function');
                }
                else
                {
                    func(result);
                }
            }
        })
        .catch((error) => {
            console.warn('Error:', error);
        });
    }

    var _findAddress = function (text) {
        if (text != null || text != '') {
            var findArr = [
                {
                    url: config.findService
                },
                {
                    key: config.key,
                    text: text,
                    countries: config.country // this can be GB (single) or GB, US, CA
                },
                function (data) {
                    _findListOfAddress(data);
                }
            ];
            _makeRequest.apply(null, findArr);
        }
    };

    var _findListOfAddress = function (data) {
        if (data.Items.length) {
            var item = data.Items[0];
            if (item.Type === "Postcode" || item.Type === 'BuildingNumber' || item.Type === 'Street') {
                var findArr = [
                    {
                        url: config.findService
                    },
                    {
                        key: config.key,
                        text: item.Text,
                        countries: config.country, // this can be GB (single) or GB, US, CA
                        container: item.Id // id is recieved from previous ajax request
                    },

                    function createResultList(data) {
                        var items = data.Items.map(function (suggestion) {
                            return {
                                label: suggestion.Text + ", " + suggestion.Description,
                                value: '',
                                data: suggestion
                            };
                        });

                        _createHtmlResultsContainer(items);
                    }
                ];
                _makeRequest.apply(null, findArr);
            } else {
                var items = data.Items.map(function (suggestion) {
                    return {
                        label: suggestion.Text + ", " + suggestion.Description,
                        value: '',
                        data: suggestion
                    };
                });
                _createHtmlResultsContainer(items);
            }
        }
    };

    var _retrieveAddress = function (id) {
        if (id != null || id != '') {
            var retrieveArr = [
                {
                    url: config.receiveService
                },
                {
                    key: config.key,
                    id: id,
                    field1format: config.customfield
                },
                function clearResults(data) {
                    if (data.Items.length) {
                        _clearResultsContainer();
                        _removeEnterManualField();
                        _showHiddenField();
                        _populateAddress(data);
                    }
                }
            ];
            _makeRequest.apply(null, retrieveArr);
        }
    };

    var _createHtmlResultsContainer = function (resultItems) {
        var resultsContainer = document.querySelector(selectors.resultsContainer);
        if (resultItems.length) {
            resultsContainer.innerHTML = `<ul class="address-search__results ${selectors.addressList} " size="4" />`;
            _createHtmlResultsList(resultItems);
        }
        else
        {
            resultsContainer.innerHTML = '<div class="address-search__no-results">Sorry no results found.</div>';
        }
    };

    var _clearResultsContainer = function () {
        document.querySelector(selectors.resultsContainer).innerHTML = '';
    };

    var _createHtmlResultsList = function (items) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var label = item.label;
            var itemNext = item.data.Next;
            var itemId = item.data.Id;

            var resultsList = document.querySelector(`.${selectors.addressList}`);
            resultsList.insertAdjacentHTML('beforeend','<li class="address-search__result-item" data-value="' + label + '" title="' + label + '" data-next="' + itemNext + '" data-id="' + itemId + '"><span>' + label + '</span></li>');
        }
    };

    var _showHiddenField = function () {
        const hiddenFieldContainer = document.querySelector(selectors.hiddenField);

        if (!hiddenFieldContainer) return;

        const isAlreadyVisible = hiddenFieldContainer.classList.contains(selectors.visibleFieldToggle);
        if (!isAlreadyVisible) {
            hiddenFieldContainer.classList.toggle(selectors.visibleFieldToggle);

            const firstInput = hiddenFieldContainer.querySelector('input');
            if (firstInput) {
                firstInput.focus();
            }
        }
    };

    var _removeEnterManualField = function () {
        document.querySelector(selectors.manualAddressButton).innerHTML = '';
    };

    var _populateAddress = function (data) {
        const fields = document.querySelector(selectors.root).querySelectorAll(selectors.field);
        var addressKeys = Object.keys(data.Items[0]);
        for (var key = 0; key < addressKeys.length; key++) {
            [...fields].filter(getItemAttribute);

            function getItemAttribute(item){
                var itemAttr = item.getAttribute('data-address-key');
                if (itemAttr === addressKeys[key]) {
                    item.value = data.Items[0][itemAttr];
                    item.removeAttribute('aria-invalid');
                    item.nextElementSibling.classList.remove('visible');
                }
            }
        }
    };

    var _bindEvents = function () {
        document.querySelector(selectors.searchButton).addEventListener('click', function(e){
            e.preventDefault();
            var inputValue = document.querySelector(selectors.searchField).value;
            if (inputValue) {
                _findAddress(inputValue);
            }
        })

        eventBus.subscribe(formEvents.formSubmitted, function () {
            _showHiddenField();
        });

        document.querySelector(selectors.resultsContainer).addEventListener('click', function(e){
                e.preventDefault();
                if(e.target && e.target.nodeName === 'SPAN') {
                    var itemSelectedAttribute = e.target.parentElement.getAttribute('data-id');
                    _retrieveAddress(itemSelectedAttribute);
                }
        })

        document.querySelector(selectors.manualAddressButton).addEventListener('click', function(e){
            e.preventDefault();
            _showHiddenField();
            _removeEnterManualField();
        })

        //FUNCTIONALITY below IS CURRENTLY BROKEN AND IS DUE TO BE FIXED IN BUG: 83642. Recommended development is to handle this check in the api endpoint in project-zen and return a response that can be handled in this script to return a warning message.

        // $(el).on('click', '.form-button-group__check-postcode', function (e) {
        //     const postcodeFieldInput = $(selectors.postcodeField).val();
        //     var postcodeCleaned = postcodeFieldInput.replace(/\s/g, '');
        //     var postcodeSliced = postcodeCleaned.slice(0, -3);
        //     $(selectors.warningMessage).remove();
        //     $.each(config.excludedPostcodes, function (i, postcode) {
        //         if (postcodeSliced.toUpperCase() === postcode) {
        //             e.preventDefault();
        //             $(selectors.warningMessageLocation).append(
        //                 '<span class="form-field-group__warningMessage">'+config.warningmessage+'</span>'
        //             )
        //             return false; //breaks out of the loop to prevent checking the rest of the postcodes
        //         }
        //     })
        // });

        document.addEventListener('mouseup', function(event) {
            var resultsBox = document.querySelector(`.${selectors.addressList}`);
            if(resultsBox && !resultsBox.contains(event.target)){
                _clearResultsContainer();
            }
        });

        document.addEventListener('keydown' , function(event) {
            var resultsBox = document.querySelector(`.${selectors.addressList}`);
            event = event || window.event;
            if (resultsBox && event.key === 'Escape') {
                _clearResultsContainer();
            }
        });
    };


    var _getSettings = function () {
        var pcaField = document.querySelector(selectors.searchField);
        var apiKey = pcaField.getAttribute('data-api-key');
        var country = pcaField.getAttribute('data-country');
        var findService = pcaField.getAttribute('data-find-service');
        var receiveService = pcaField.getAttribute('data-receive-service');
        var warningMessage = pcaField.getAttribute('data-warning-message');
        var postcodes = pcaField.getAttribute('data-postcodes');
        if (pcaField) {
            config.key = apiKey;
            config.findService = `${findService}noorder`;
            config.receiveService = `${receiveService}noorder`;
            config.country = country;
            config.warningmessage = warningMessage;
            config.excludedPostcodes = postcodes;
        } else {
            console.warn('no data attributes or no values for each data attributes, please check your configuration');
        }
    };

    var init = function () {
        var root = document.querySelector(selectors.root);
        var searchField = document.querySelector(selectors.searchField);
        if (root && searchField) {
            _getSettings();
            _bindEvents();
        }
    };

    return {
        init: init
    };
};